export class CustomizationValueDataImage {

  static create(fileID : number) : CustomizationValueDataImage {
    const newCustomization = new CustomizationValueDataImage();
    newCustomization.fileID = fileID;
    return newCustomization;
  }

  static getFileID(customizationValueDataImage : CustomizationValueDataImage) {
    return customizationValueDataImage.fileID;
  }

  static setFileID(
    customizationValueDataImage : CustomizationValueDataImage,
    fileID : number,
  ) {
    // eslint-disable-next-line no-param-reassign
    customizationValueDataImage.fileID = fileID;
  }

  public fileID : number = 0;
}
